import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { cardStyles as styles } from '../styles/card'

function Faq(props) {
  const { classes } = props;

  let faq
  switch (props.lang) {
    case "de":
      faq = 'Haufig gestellte Fragen'
      break;
    case "en":
      faq = 'Frequently Asked Questions'
      break;
    case "fr":
      faq = 'Foire aux questions'
      break;
    case 'nl':
    default:
      faq = 'Naar de veelgestelde vragen'
  }

  return (
    <Card className={classes.card}>
      <a
        target="_blank"
        style={{ fontWeight: 400 }}
        // Using target="_blank" without rel="noopener noreferrer" is a security risk: see https://mathiasbynens.github.io/rel-noopener  react/jsx-no-target-blank
        rel="noopener noreferrer"
        href="https://www.energiesparen.be/stroomvoorspeller/faq">
        <CardHeader
          className={classes.cardHeader + ' bgdarkbluegreen' }
          disableTypography
          title={faq}
        />
      </a>
    </Card>
  );
}

Faq.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Faq);